
import React, { Component } from "react";
import { Modal, Form, Col, Button, Row } from "react-bootstrap";
import { graphql } from "react-apollo"
import { gql } from "apollo-boost";
import * as Cookies from "es-cookie"
import './_buttonpopup.scss';

const ADD_CLASS_PERIODS = gql`
  mutation($params: AddClassPeriods) {
    addClassPeriods(params: $params)
  }
`;

class PeriodCreationModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      branch_id: '',
      branchError: '',
      exam_id: '',
      examError: '',
      count: 0,
      update: [],
      dataClear: 1,
      periodError: "",
      loadingSpinner: 0,
      submitted: false,
      getExams: [],
      defaultvalue: 0,
      currentStep: 1,
      submitError: ""
    };
  }


  addRow = () => {
    let countValue = parseInt(this.state.count)
    this.setState({
      count: countValue + 1
    })

    let event = {
      target: {
        name: "period_name",
        value: ""
      }
    }
    this.handleChange(event, countValue + 1)
  }
  handleChange = (e, i) => {
    let name = e.target.name;
    let value = e.target.value;


    this.setState(preState => {

      let array = preState.update;

      let array1 = [];

      if (array.length > 0) {
        if (array[i] != undefined) {
          array.map((item2, index) => {
            if (i == index) {
              let period_name = item2.period_name;
              let period_startTime = item2.period_startTime;
              let period_endTime = item2.period_endTime;
              if (name == "period_name") {
                period_name = value

              } else if (name == "period_startTime") {
                period_startTime = value;
              } else {
                period_endTime = value
              }
              array1.push({ period_name: period_name, period_startTime: period_startTime, period_endTime: period_endTime, period_name_error: "", period_startTime_error: "", period_endTime_error: "" })
            } else {
              array1.push({ ...item2 })
            }
          })
        } else {
          array1.push(...array, { period_name: "", period_startTime: "", period_endTime: "", period_name_error: "", period_startTime_error: "", period_endTime_error: "" })
        }

      } else {
        array1.push({ period_name: "", period_startTime: "", period_endTime: "", period_name_error: "", period_startTime_error: "", period_endTime_error: "" })
      }
      return {
        update: array1
      }

    })
  }

  handleSubmit = () => {

    if (this.state.branch_id == "") {
      this.setState({ branchError: "Please Select Branch" })
      return ""
    }
    if (this.state.exam_id == "") {
      this.setState({ examError: "Please Select Exam" })
      return ""
    }

    let stopExecuting = false;
    this.state.update.some((obj, i) => {

      let errorUpdate = this.state.update

      if (obj.period_name == "" || obj.period_name == undefined) {
        errorUpdate[i] = { ...obj, period_name_error: "Type period name" }
        this.setState({ update: errorUpdate })
        stopExecuting = true
        return true;
      }
      if (obj.period_startTime == "" || obj.period_startTime == undefined) {
        errorUpdate[i] = { ...obj, period_starttime_error: "Select start time" }
        this.setState({ update: errorUpdate })
        stopExecuting = true
        return true
      }
      if (obj.period_endTime == "" || obj.period_endTime == undefined) {
        errorUpdate[i] = { ...obj, period_endtime_error: "Select end time" }
        this.setState({ update: errorUpdate })
        stopExecuting = true
        return true
      }
    })

    if (stopExecuting) {
      return ""
    }

    let array = []
    if (this.state.update.length > 0) {
      this.state.update.map((item) => {
        let period_time = `${item.period_startTime} - ${item.period_endTime}`
        array.push({ period_name: item.period_name, period_time: period_time })
      })
    }
    const params = {
      branch_id: parseInt(this.state.branch_id),
      exam_id: parseInt(this.state.exam_id),
      institute_id: parseInt(Cookies.get("institutionid")),
      period_details: array
    }

    this.setState({
      loadingSpinner: 1
    });

    this.addClassPeriods(
      params
    ).catch(error => {
      console.log("catch if error");
      console.log(error);
      this.setState({
        submitError: error.graphQLErrors.map(x => x.message), loadingSpinner: 0
      });
      console.error("ERR =>", error.graphQLErrors.map(x => x.message));
    });
  }

  addClassPeriods = async (
    params) => {
    await this.props.addClassPeriods({
      variables: {
        params,
      },
      update: (store, { data }) => {
        console.log("data.finishTest", data);
        if (data.addClassPeriods) {
          this.setState({
            loadingSpinner: 0,
            currentStep: 5

          })
          setTimeout(() => {
            this.SetpageLoad();
          }, 1000);
        }
      }

    });
  };

  SetpageLoad = () => {
    this.setState({ currentStep: 1, submitError: "" });
    this.props.onHide();
  };

  deleteHandle = (i) => {

    let updatedrows = this.state.update.filter((item, index) => index != i)
    console.log("hhh", updatedrows, i);
    this.setState({
      update: updatedrows, count: this.state.count - 1
    })
  }
  componentDidUpdate() {
    if (this.props.show === true && this.state.dataClear == 0) {
      this.setState({
        dataClear: 1,
        branch_id: '',
        exam_id: '',
        examError: '',
        branchError: '',
        count: 0,
        loadingSpinner: 0,
        update: [],
        submitted: false
      })
    }
    if (this.props.show === false && this.state.dataClear == 1) {
      this.setState({ dataClear: 0 })
    }
  }


  handleInputChange = e => {
    const name = e.target.name;
    const value = e.target.value;

    let getArray = [];

    if (name == "branch") {

      if (value != "0") {
        let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == value).map((item1) => item1.exam_id))].sort();

        uniqueExams.map((val) => {
          let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
          const newObj = {
            value: individualExamData.id,
            label: individualExamData.exam
          }
          getArray.push(newObj);
        })

        this.setState({
          branch_id: value,
          branchError: '',
          exam_id: '',
          examError: '',
          count: 0,
          update: [],
          periodError: "",
          getExams: getArray

        });

      } else {
        this.setState({
          branch_id: '',
          branchError: '',
          exam_id: '',
          examError: '',
          count: 0,
          update: [],
          periodError: "",
          getExams: []
        })
      }
    }

    if (name == "exam") {

      if (value != "0") {

        this.setState({
          branchError: '',
          exam_id: value,
          examError: '',
          count: 0,
          update: [],
          periodError: "",
        })
        this.handleChange(e, 0)
      } else {
        this.setState({
          branchError: '',
          exam_id: "",
          examError: '',
          count: 0,
          update: [],
          periodError: "",
        })

      }
    }


  };

  render() {
    console.log("arrr", this.state)
    return (
      <Modal
        {...this.props}
        size="lg"
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Period Creation</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Row>
            <Col xl={12} lg={12} md={12} sm={12}>
              <Form>
                <Form.Row>
                  <Form.Group as={Col} lg={3} md={12} sm={12} controlId="SelectClass">
                    <Form.Label className="text-uppercase font-weight-bold">Branch</Form.Label>
                    <Form.Control as="select" name="branch" onChange={this.handleInputChange} value={this.state.branch_id} isInvalid={this.state.branchError}>
                      <option value={this.state.defaultvalue}>--Select Branch--</option>
                      {this.props.globals.globalBranches.map(branchdata => (
                        <option key={branchdata.id} value={branchdata.id}>
                          {branchdata.branch_name}
                        </option>
                      ))}
                    </Form.Control>
                    <Form.Text className="form-text text-danger" type="invalid">
                      {this.state.branchError}
                    </Form.Text>
                  </Form.Group>


                  <Form.Group as={Col} lg={3} md={12} sm={12} controlId="Selectexam">
                    <Form.Label className="text-uppercase font-weight-bold">Exam</Form.Label>
                    <Form.Control as="select" name="exam" onChange={this.handleInputChange} value={this.state.exam_id} isInvalid={this.state.examError}>
                      <option value={this.state.defaultvalue}>--Select Exam--</option>
                      {this.state.getExams.map(item => (
                        <option key={item.value} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </Form.Control>
                    <Form.Text className="form-text text-danger" type="invalid">
                      {this.state.examError}
                    </Form.Text>
                  </Form.Group>

                </Form.Row>
              </Form>
            </Col>
          </Row>

          {
            this.state.update.length > 0 ? (this.state.update.map((item, i) => (
              <>

                <div className="row mb-4 mt-3">

                  <div className="col-sm-3 mbottom">
                    <h6>Period Name</h6>
                    <input type="text" className="form-control" placeholder="Enter Period Name" onChange={(e) => this.handleChange(e, i)} value={item.period_name} name="period_name" />
                    <span className="text-danger">{item.period_name_error}</span>
                  </div>
                  <div className="col-sm-3 col-4 mbottom">
                    <h6>Period Start Time</h6>
                    <input type="time" onChange={(e) => this.handleChange(e, i)} value={item.period_startTime} name="period_startTime" />
                    <div>
                      <span className="text-danger">{item.period_starttime_error}</span>
                    </div>
                  </div>
                  <div className="col-sm-3 col-4 mbottom">
                    <h6>Period End Time</h6>
                    <input type="time" onChange={(e) => this.handleChange(e, i)} value={item.period_endTime} name="period_endTime" />
                    <div>
                      <span className="text-danger">{item.period_endtime_error}</span>
                    </div>
                  </div>
                  <div className="col-sm-3 col-4 mt-3">
                    {
                      this.state.update.length > 1 ? (
                        <button onClick={() => this.deleteHandle(i)} className="btn btn-danger"><i className="far fa-trash-alt" style={{fontSize:"15px"}} /></button>
                      ) : ("")
                    }
                  </div>
                </div>

              </>
            ))) : ("")
          }
          {
            this.state.update.length > 0 ? (
              <div>
                <Button type="button" onClick={this.addRow}  style={{backgroundColor:"#213046",color:"#fff"}}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus" viewBox="0 0 16 16">
                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                  </svg>
                </Button>
              </div>
            ) : ("")
          }
        </Modal.Body>
        <Modal.Footer variant="white" >
          <Row>
            <Col sm={12}>
              {this.state.currentStep == 5 ? (
                <Form.Text className="form-text text-success mb-2 " style={{ textAlign: "center" }}>
                  Periods Create Successfully
                </Form.Text>
              ) : (
                <Form.Text className="form-text text-danger mb-2" style={{ textAlign: "center" }}>
                  {this.state.submitError}
                </Form.Text>
              )}
            </Col>
          </Row>
          <Row>
            <Col sm={12} style={{ display: "block", textAlign: "center" }}>
              <button className="Creationsubmited_btn  text-uppercase" style={{width:"131px"}} onClick={(e) => this.handleSubmit()}>
                {
                  this.state.loadingSpinner == 1 ? (
                    <span className="spinner-border spinner-border-sm"></span>
                  ) : ""
                }
                Create Period</button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    );

  }
}
export default graphql(ADD_CLASS_PERIODS, {
  name: "addClassPeriods"
})(PeriodCreationModal);


 